module.exports = __webpack_public_path__ + "static/media/new_sqwad_logo.0e5ab960.png";